<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="primary">
      @if ((isEnd | async) === false) {
        <ion-button fill="clear" (click)="next()">
          {{ 'wizard.next' | translate }}
        </ion-button>
      }
      @if (isEnd | async) {
        <ion-button fill="clear" (click)="done()">
          {{ 'core.done' | translate }}
        </ion-button>
      }
    </ion-buttons>
    <ion-title>{{ 'wizard.title' | translate }}</ion-title>
    <ion-buttons slot="secondary">
      <ion-button fill="clear" (click)="done()">
        {{ 'wizard.skip' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen class="ion-padding">
  <swiper-container #swiper (swiperslidechange)="slideChanged()">
    <swiper-slide class="slide">
      <ion-icon name="globe" class="ion-align-self-center"></ion-icon>
      <h2 class="ion-align-self-center">{{ 'settings.lang.title' | translate }}</h2>
      <p class="ion-align-self-center">
        {{ 'wizard.language.message' | translate }}
      </p>

      <ion-radio-group [value]="translate.currentLang" (ionChange)="selectLanguage($event)">
        @for (lang of languages; track lang) {
          <ion-item>
            <ion-label>{{ lang.translationKey | translate }}</ion-label>
            <ion-radio slot="start" [value]="lang.lang" slot="end"></ion-radio>
          </ion-item>
        }
      </ion-radio-group>

      <p class="ion-align-self-center">
        <ion-button fill="clear" (click)="next()">
          {{ 'wizard.next' | translate }}
        </ion-button>
      </p>
    </swiper-slide>

    <swiper-slide class="slide">
      <img class="ion-align-self-center" src="assets/wizard/icon-badge.svg" />
      <h2 class="ion-align-self-center">{{ 'wizard.push-notification.header' | translate }}</h2>
      <p class="ion-align-self-center">
        {{ 'wizard.push-notification.message' | translate }}
      </p>

      <ion-item>
        <ion-toggle #push name="push" [checked]="push$ | async" (ionChange)="togglePush(push)">
          {{ 'wizard.push-notification.activate' | translate }}
        </ion-toggle>
      </ion-item>

      <ion-item>
        <ion-label class="ion-text-wrap">
          <h2>{{ 'settings.push.channel.header' | translate }}</h2>
          <p>{{ 'settings.push.channel.subheader' | translate }}</p>
        </ion-label>
      </ion-item>

      <ion-item>
        <ion-toggle #general name="general" [disabled]="!push.checked" [checked]="(pushChannels$ | async)?.general" (ionChange)="togglePushChannel(general)">
          {{ 'settings.push.channel.general' | translate }}
        </ion-toggle>
      </ion-item>

      <ion-item>
        <ion-toggle #sports name="sports" [disabled]="!push.checked" [checked]="(pushChannels$ | async)?.sports" (ionChange)="togglePushChannel(sports)">
          {{ 'settings.push.channel.sports' | translate }}
        </ion-toggle>
      </ion-item>

      <ion-item>
        <ion-toggle #library name="library" [disabled]="!push.checked" [checked]="(pushChannels$ | async)?.library" (ionChange)="togglePushChannel(library)">
          {{ 'settings.push.channel.library' | translate }}
        </ion-toggle>
      </ion-item>

      <ion-item>
        <ion-toggle #healthPassport name="healthPassport" [disabled]="!push.checked" [checked]="(pushChannels$ | async)?.healthPassport" (ionChange)="togglePushChannel(healthPassport)">
          {{ 'settings.push.channel.healthPassport' | translate }}
        </ion-toggle>
      </ion-item>

      <p class="ion-align-self-center">
        <ion-button fill="clear" (click)="done()">
          {{ 'core.done' | translate }}
        </ion-button>
      </p>
    </swiper-slide>
  </swiper-container>
</ion-content>
